import styled from 'styled-components';

/* The page tabs live in a full-bleed row that pulls itself out to the page
   gutters; inside a modal that negative margin would hang off the dialog. */
export const PlaybookTabs = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;

  @media (max-width: 800px) {
    gap: 12px;
  }
`;
